import React, { useMemo } from "react";
import type { LabelProps } from "@fluentui/react-label";
import type { DropdownProps, OptionOnSelectData, SelectionEvents } from "@fluentui/react-combobox";
import { Dropdown, Option } from "@fluentui/react-combobox";
import { Label } from "@fluentui/react-label";
import { SelectValueOption } from "../domain/SelectValueOption";

interface SelectMultiFilterProps {
  filterStyle: string;
  controlId: string;
  controlStyle: string;
  labelProps: LabelProps;
  labelText: string;
  labelStyle: string;
  placeholderText: string;
  selectOptions: SelectValueOption[];
  selectProps: DropdownProps;
  selectedOptions: string[];
  disabled: boolean;
  setSelectedOptions: (options: string[]) => void;
}

const SelectMultiFilter = (props: SelectMultiFilterProps): React.JSX.Element => {
  // Skip rendering when no options are provided.
  if (props.selectOptions == null || props.selectOptions.length == 0) {
    return <></>;
  }

  const displayValue = useMemo(() => {
    let selectedNames: string[] = [];
    props.selectOptions.forEach((option: SelectValueOption) => {
      if (props.selectedOptions.includes(option.id)) {
        selectedNames.push(option.name);
      }
    });
    return selectedNames.join(", ");
  }, [props.selectOptions, props.selectedOptions]);

  const onOptionSelect = (_: SelectionEvents, data: OptionOnSelectData) => {
    props.setSelectedOptions(data.selectedOptions);
  };

  return (
    <div className={props.filterStyle}>
      <div className={props.labelStyle}>
        <Label htmlFor={props.controlId} {...props.labelProps}>
          {props.labelText}
        </Label>
      </div>
      <div className={props.controlStyle}>
        <Dropdown
          id={props.controlId}
          multiselect={true}
          placeholder={props.placeholderText}
          selectedOptions={props.selectedOptions}
          value={displayValue}
          onOptionSelect={onOptionSelect}
          disabled={props.disabled}
          {...props.selectProps}
        >
          {props.selectOptions.map((opt, index) => (
            <Option key={index} value={opt.id}>
              {opt.name}
            </Option>
          ))}
        </Dropdown>
      </div>
    </div>
  );
};

export default SelectMultiFilter;
